import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFeatureDoc,
  fetchUserMappedFeatureDataV1,
} from "../../redux/dashboard-features/featuresSlice";
import { fetchFeaturesDocumentationData } from "../../redux/dashboard-features/featuresSlice";
import { selectUser } from "../auth/auth.selector";
import Loader from "../ui/Loader";
import { WTFNewRoundLogo } from "../../exports/Images";
import "../../styles/docs/toggle-switch.css";

const LayoutMenus = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const [toggle, setToggle] = useState(false);

  const {
    userMappedFeaturesV1,
    userMappedFeaturesV1Loading,
    // userMappedFeaturesV1Error,
  } = useSelector((state) => state.features);

  const { featureDoc, featureDocLoading } = useSelector(
    (state) => state.features
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [pinnedFeatures, setPinnedFeatures] = useState(() => {
    if (!userInfoData?.uid) return [];

    const storageKey = `pinnedFeatures_${userInfoData.uid}`;
    const saved = localStorage.getItem(storageKey);
    if (!saved) return [];

    try {
      return JSON.parse(saved);
    } catch (error) {
      console.error("Error parsing pinned features:", error);
      return [];
    }
  });

  const debounceTimeout = useRef();

  useEffect(() => {
    if (
      !userMappedFeaturesV1Loading &&
      userMappedFeaturesV1?.data &&
      userInfoData?.uid
    ) {
      const validFeatures = pinnedFeatures.filter((pinnedFeature) =>
        userMappedFeaturesV1.data.some((group) =>
          group.sub_menu.some((feature) => feature.uid === pinnedFeature.uid)
        )
      );

      if (validFeatures.length !== pinnedFeatures.length) {
        setPinnedFeatures(validFeatures);
        const storageKey = `pinnedFeatures_${userInfoData.uid}`;
        localStorage.setItem(storageKey, JSON.stringify(validFeatures));
      }
    }
  }, [userMappedFeaturesV1Loading, userMappedFeaturesV1, userInfoData?.uid]);

  useEffect(() => {
    if (!userInfoData?.uid) {
      setPinnedFeatures([]);
    }
  }, [userInfoData?.uid]);

  useEffect(() => {
    if (userInfoData?.uid || userInfoData?.user_id) {
      const filters = {
        user_id: userInfoData?.uid || userInfoData?.user_id || "",
      };

      dispatch(
        fetchUserMappedFeatureDataV1({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }, [dispatch, userInfoData]);

  useEffect(() => {
    if (toggle) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        const docFilters = {
          page: 1,
          limit: 10,
          feature_relevant_for: userInfoData?.account_type || "",
        };
        if (searchTerm.trim()) {
          docFilters.search = searchTerm.trim();
        }
        dispatch(
          fetchFeaturesDocumentationData({
            filters: docFilters,
            token: userInfoData?.token || "",
          })
        );
      }, 500);
      return () => clearTimeout(debounceTimeout.current);
    }
  }, [
    toggle,
    searchTerm,
    // userInfoData?.account_type,
    // userInfoData?.token,
    // dispatch,
  ]);

  const handleToggle = () => {
    setToggle((prev) => {
      const next = !prev;
      if (next) {
        dispatch(clearFeatureDoc());
      }
      return next;
    });
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const togglePin = (feature) => {
    if (!userInfoData?.uid) return;

    const isFeatureAccessible = userMappedFeaturesV1?.data?.some((group) =>
      group.sub_menu.some((f) => f.uid === feature.uid)
    );

    if (!isFeatureAccessible) {
      console.error("Attempted to pin inaccessible feature");
      return;
    }

    setPinnedFeatures((prev) => {
      const isPinned = prev.some((f) => f.uid === feature.uid);
      const newPinned = isPinned
        ? prev.filter((f) => f.uid !== feature.uid)
        : [...prev, feature];

      const storageKey = `pinnedFeatures_${userInfoData.uid}`;
      localStorage.setItem(storageKey, JSON.stringify(newPinned));
      return newPinned;
    });
  };

  if (userMappedFeaturesV1Loading) {
    return (
      <div className="loading-container">
        <Loader />
      </div>
    );
  }

  if (!userMappedFeaturesV1?.status || !userMappedFeaturesV1?.data?.length) {
    return (
      <div className="layout-container">
        <img src={WTFNewRoundLogo} alt="WTF" className="wtf-logo-center" />
      </div>
    );
  }

  const filteredData = userMappedFeaturesV1.data
    .map((menuGroup) => ({
      ...menuGroup,
      sub_menu: menuGroup.sub_menu.filter((subItem) =>
        subItem.label.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((menuGroup) => menuGroup.sub_menu.length > 0);

  return (
    <div className="menu-container">
      <div
        className="menu-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <div className="page-heading">Accessible Features </div>
          <label className="docs-toggle-switch">
            <input
              type="checkbox"
              className="docs-toggle-switch__input"
              checked={toggle}
              onChange={handleToggle}
            />
            <span className="docs-toggle-switch__slider" />
          </label>
        </div>
        <div className="home-layout-searchbar">
          <div className="search-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="#666"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 21L16.65 16.65"
                stroke="#666"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search features..."
            className="pro-searchbar-home-layout"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </div>

      {/* Only show pinned and filtered features if toggle is OFF */}
      {!toggle && pinnedFeatures.length > 0 && (
        <div className="menu-group">
          <div className="menu-group-header">Pinned Features</div>
          <div className="accessible-pages-grid">
            {pinnedFeatures.map((feature) => (
              <div className="accessible-card" key={feature.uid}>
                <span className="accessible-card-label">{feature.label}</span>
                <div className="accessible-card-actions">
                  <button
                    className="pin-button pinned"
                    onClick={(e) => {
                      e.stopPropagation();
                      togglePin(feature);
                    }}
                  >
                    📌
                  </button>
                  <span
                    className="accessible-card-arrow"
                    onClick={() => window.open(feature.path, "_blank")}
                  >
                    <span className="arrow-circle">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="16" cy="16" r="16" fill="#C00" />
                        <path
                          d="M13 10L19 16L13 22"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Only show filtered features if toggle is OFF */}
      {!toggle &&
        filteredData.map((menuGroup) => (
          <div key={menuGroup.menu_id} className="menu-group">
            <div className="menu-group-header">{menuGroup.label}</div>
            <div className="accessible-pages-grid">
              {menuGroup.sub_menu.map((feature) => (
                <div className="accessible-card" key={feature.uid}>
                  <span className="accessible-card-label">{feature.label}</span>
                  <div className="accessible-card-actions">
                    <button
                      className={`pin-button ${
                        pinnedFeatures.some((f) => f.uid === feature.uid)
                          ? "pinned"
                          : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        togglePin(feature);
                      }}
                    >
                      📌
                    </button>
                    <span
                      className="accessible-card-arrow"
                      onClick={() => window.open(feature.path, "_blank")}
                    >
                      <span className="arrow-circle">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="16" cy="16" r="16" fill="#C00" />
                          <path
                            d="M13 10L19 16L13 22"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      {/* Show feature docs as cards when toggle is ON */}
      {toggle && (
        <div className="menu-group">
          <div className="menu-group-header">Dashboard Docs And Guidance </div>
          <div className="accessible-pages-grid">
            {featureDocLoading || !featureDoc ? (
              <Loader size={"large"} />
            ) : (
              featureDoc?.data?.map((doc) => (
                <div
                  className="accessible-card"
                  key={doc.uid}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(`/dashboard-docs?uid=${doc.uid}`, "_blank")
                  }
                >
                  <span className="accessible-card-label">
                    {doc.feature_doc_name || doc.feature_name}
                  </span>
                  <div className="accessible-card-actions">
                    <span className="accessible-card-arrow">
                      <span className="arrow-circle">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="16" cy="16" r="16" fill="#C00" />
                          <path
                            d="M13 10L19 16L13 22"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LayoutMenus;
